// extracted by mini-css-extract-plugin
module.exports = {"expensionHeader":"hakkimizda_expensionHeader_25PP4"};